import { __extends } from "tslib";
import * as React from 'react';
import s from '../solution-page-views/solution-info/solution-info.scss';
import { PreviewMode } from '../preview-elements/preview-context';
import { AddItem, Proportion, Box } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
var CarouselPreviewWrapper = /** @class */ (function (_super) {
    __extends(CarouselPreviewWrapper, _super);
    function CarouselPreviewWrapper(props) {
        return _super.call(this, props) || this;
    }
    CarouselPreviewWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(PreviewMode.Consumer, null, function (value) {
            return value.isPreview && !hasPictures(_this.props) ? (React.createElement(Box, { className: s.previewContainer, maxHeight: 471, minHeight: 171 },
                React.createElement(Proportion, { aspectRatio: 9 / 6 },
                    React.createElement(AddItem, { size: "large", onClick: function () { return onClickImageAdd(value.appId); } },
                        React.createElement(PreviewCarouselText, null))))) : (_this.props.children);
        }));
    };
    return CarouselPreviewWrapper;
}(React.Component));
export { CarouselPreviewWrapper };
var hasPictures = function (_a) {
    var previews = _a.previews;
    return previews !== undefined && previews.length > 0;
};
var onClickImageAdd = function (appId) {
    window.open("https://dev.wix.com/dc3/my-apps/" + appId + "/market/info/basic-info");
};
var PreviewCarouselText = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t;
    return t('solution.page.preview.carouselText');
});
//# sourceMappingURL=carousel-wrapper.js.map